// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__TlJoX","label":"LabeledBox_label__2YGsE"};